"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.configStore = exports.App = exports.APP_CONTROLLER_REDUCERS_ACTIONS = exports.APP_CONTROLLER_REDUCERS = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _redux = require("redux");

var _reduxSaga = _interopRequireDefault(require("redux-saga"));

var _reactRedux = require("react-redux");

var _history = require("history");

var _connectedReactRouter = require("connected-react-router");

var _GoogleTagManager = _interopRequireDefault(require("./GoogleTagManager"));

var _Core = _interopRequireDefault(require("./Core"));

var _context = _interopRequireDefault(require("./Reducers/context"));

var _errorCatcher = _interopRequireWildcard(require("./Reducers/errorCatcher"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// setting up global vars
window.s = window.s || {};
window.dataLayerGTM = window.dataLayerGTM || []; // window.flexibility = flexibility;

const configStore = (rootReducers, rootSagas, reduxTools) => {
  const sagaMiddleware = (0, _reduxSaga.default)();
  const history = (0, _history.createBrowserHistory)();
  let composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || _redux.compose;

  if (!reduxTools) {
    composeEnhancers = _redux.compose;
  }

  const preloadedState = window.__PRELOADED_STATE__;
  delete window.__PRELOADED_STATE__;
  const mystore = (0, _redux.createStore)(rootReducers(history), preloadedState, composeEnhancers((0, _redux.applyMiddleware)(sagaMiddleware, (0, _connectedReactRouter.routerMiddleware)(history))));
  sagaMiddleware.run(rootSagas);
  return {
    store: mystore,
    history
  };
};
/**
 * App component.
 * @returns {object} App rendered.
 */


exports.configStore = configStore;

const App = _ref => {
  let {
    projectId,
    urlLibrary,
    modulesLibrary,
    rootReducers,
    rootSagas,
    reduxTools,
    ModalComponent,
    defaultErrorScreen,
    gtmId
  } = _ref;
  // it must append modules 500 and 404 on modules and urlLibrary
  const newModulesLibrary = modulesLibrary;
  const module404 = newModulesLibrary.find(module => module.id === '404');
  const module500 = newModulesLibrary.find(module => module.id === '500');

  if (!module404) {
    newModulesLibrary.push({
      id: '404',
      loader: /*#__PURE__*/_react.default.lazy(() => Promise.resolve().then(() => _interopRequireWildcard(require('./Screens/NotFound'))))
    });
  }

  if (!module500) {
    newModulesLibrary.push({
      id: '500',
      loader: /*#__PURE__*/_react.default.lazy(() => Promise.resolve().then(() => _interopRequireWildcard(require('./Screens/Error'))))
    });
  }

  const {
    store,
    history
  } = configStore(rootReducers, rootSagas, reduxTools);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRedux.Provider, {
    store: store,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_connectedReactRouter.ConnectedRouter, {
      history: history,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_GoogleTagManager.default, {
        gtmId: gtmId,
        dataLayerName: "dataLayerGTM"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Core.default, {
        history: history,
        projectId: projectId,
        urlLibrary: urlLibrary,
        modulesLibrary: newModulesLibrary,
        defaultErrorScreen: defaultErrorScreen
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(ModalComponent, {
        projectId: projectId
      })]
    })
  });
};

exports.App = App;
App.propTypes = {
  ModalComponent: _propTypes.default.func.isRequired,
  defaultErrorScreen: _propTypes.default.object,
  reduxTools: _propTypes.default.bool,
  gtmId: _propTypes.default.string
};
App.defaultProps = {
  defaultErrorScreen: null,
  reduxTools: false,
  gtmId: 'GTM-KDQ556C'
};
var _default = App;
/* REDUCERS */

exports.default = _default;
const APP_CONTROLLER_REDUCERS = {
  context: _context.default,
  errorCatcher: _errorCatcher.default
};
exports.APP_CONTROLLER_REDUCERS = APP_CONTROLLER_REDUCERS;
const APP_CONTROLLER_REDUCERS_ACTIONS = {
  errorCatcherActions: _errorCatcher.actions
};
exports.APP_CONTROLLER_REDUCERS_ACTIONS = APP_CONTROLLER_REDUCERS_ACTIONS;

//# sourceMappingURL=index.js.map